import { Component } from '@angular/core';

@Component({
  selector: 'greco-welcome',
  templateUrl: './welcome.component.html',
  styleUrls: ['./welcome.component.scss'],
})
export class WelcomeComponent {}
